import React from 'react';
const CalenderSVG = ({ color = 'black', className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group 1437252864">
        <path
          id="Vector"
          d="M1 10.2691C1 6.78799 1 5.04743 2.08145 3.96597C3.16291 2.88452 4.90347 2.88452 8.38461 2.88452H12.0769C15.558 2.88452 17.2987 2.88452 18.3801 3.96597C19.4615 5.04743 19.4615 6.78799 19.4615 10.2691V12.1153C19.4615 15.5964 19.4615 17.337 18.3801 18.4184C17.2987 19.4999 15.558 19.4999 12.0769 19.4999H8.38461C4.90347 19.4999 3.16291 19.4999 2.08145 18.4184C1 17.337 1 15.5964 1 12.1153V10.2691Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          id="Vector_2"
          d="M5.61548 2.88462V1.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          id="Vector_3"
          d="M14.8462 2.88462V1.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          id="Vector_4"
          d="M1.46143 7.5H18.9999"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          id="Vector_5"
          d="M15.7692 14.8845C15.7692 15.3943 15.356 15.8076 14.8462 15.8076C14.3364 15.8076 13.9231 15.3943 13.9231 14.8845C13.9231 14.3747 14.3364 13.9614 14.8462 13.9614C15.356 13.9614 15.7692 14.3747 15.7692 14.8845Z"
          fill={color}
        />
        <path
          id="Vector_6"
          d="M15.7692 11.1924C15.7692 11.7022 15.356 12.1154 14.8462 12.1154C14.3364 12.1154 13.9231 11.7022 13.9231 11.1924C13.9231 10.6825 14.3364 10.2693 14.8462 10.2693C15.356 10.2693 15.7692 10.6825 15.7692 11.1924Z"
          fill={color}
        />
        <path
          id="Vector_7"
          d="M11.1538 14.8845C11.1538 15.3943 10.7405 15.8076 10.2307 15.8076C9.72088 15.8076 9.30762 15.3943 9.30762 14.8845C9.30762 14.3747 9.72088 13.9614 10.2307 13.9614C10.7405 13.9614 11.1538 14.3747 11.1538 14.8845Z"
          fill={color}
        />
        <path
          id="Vector_8"
          d="M11.1538 11.1924C11.1538 11.7022 10.7405 12.1154 10.2307 12.1154C9.72088 12.1154 9.30762 11.7022 9.30762 11.1924C9.30762 10.6825 9.72088 10.2693 10.2307 10.2693C10.7405 10.2693 11.1538 10.6825 11.1538 11.1924Z"
          fill={color}
        />
        <path
          id="Vector_9"
          d="M6.53854 14.8845C6.53854 15.3943 6.12526 15.8076 5.61546 15.8076C5.10566 15.8076 4.69238 15.3943 4.69238 14.8845C4.69238 14.3747 5.10566 13.9614 5.61546 13.9614C6.12526 13.9614 6.53854 14.3747 6.53854 14.8845Z"
          fill={color}
        />
        <path
          id="Vector_10"
          d="M6.53854 11.1924C6.53854 11.7022 6.12526 12.1154 5.61546 12.1154C5.10566 12.1154 4.69238 11.7022 4.69238 11.1924C4.69238 10.6825 5.10566 10.2693 5.61546 10.2693C6.12526 10.2693 6.53854 10.6825 6.53854 11.1924Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default CalenderSVG;
